// ----------------------------------------------------------------------
// <copyright file="Izenda.InitValidate.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  "use strict";
  /* Implement custom validators and further global settings of validate.js */

  var validate = require('validate.js');

  /**
   * A validator that invoke async function of a store. Usually uses for server-side
   * validation.
   * @param  {any} value         Value to validate
   * @param  {Object} options
   * @param  {string} key        Validating field
   * @param  {Object} attributes Object to validate
   * @return {Promise}           A promise of action result
   */
  validate.validators.storeAction = function (value, options, key, attributes){
    ensure(options,'storeAction validator options cannot be nil');
    ensure(options.action, 'storeAction validator options must contains "action" string');
    ensure(options.store, 'storeAction validator options must contains "store" instance');

    var result = options.store[options.action].call(options.store, value, key, attributes);

    return Promise.resolve(result);
  };

  validate.validators.action = function (value, options, key, attributes){
    return Promise.resolve(options(value, key, attributes));
  }
}();



// WEBPACK FOOTER //
// ./ui/share/validation/Izenda.initValidate.js